export default {"src":"/_next/static/media/ic_new_tooltip_i.78d5e368.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};